import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './UserMenuOptions.scss'
const UserMenuOptions = ({ userTerminals, currentTerminalId, onSelectTerminal, onLogout }) => {
  //TODO: use _.partition()?
  return (
    <div className="user-menu-options">
      {userTerminals.length > 0 && (
        <div className="terminal-options">
          {userTerminals.map(terminal => {
            const isCurrentTerminal = terminal.id === currentTerminalId
            return (
              <div
                className={classNames('terminal-option', { 'current-terminal': isCurrentTerminal })}
                key={terminal.id}
                onClick={() => onSelectTerminal(terminal.id, terminal.roles)}
              >
                <div className={`active-indicator ${isCurrentTerminal ? 'active' : ''}`}></div>

                <div>
                  <span className={`option-tag`}>{isCurrentTerminal ? 'Active Terminal' : 'Terminal'}</span>
                  <h4>
                    {terminal.terminal} {terminal.port}
                  </h4>
                </div>
              </div>
            )
          })}
        </div>
      )}

      <div className="logout-option" onClick={onLogout}>
        <i className="fa fa-sign-out" aria-hidden="true" />
        <span className="logout-text">Log out</span>
      </div>
    </div>
  )
}

UserMenuOptions.propTypes = {
  userTerminals: PropTypes.array.isRequired,
  currentTerminalId: PropTypes.string.isRequired,
  onSelectTerminal: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired
}
export default UserMenuOptions
